import React from "react";
import { Box } from "@mui/material";
import { BRAND } from "../constants/colors";

const BLUE = BRAND.primary;

/** Product art — standard brand blue on ink. */
export default function AuthHero({ compact = false }) {
  return (
    <Box
      aria-hidden
      sx={{
        width: compact ? 220 : "min(360px, 86%)",
        maxWidth: 380,
        mx: "auto",
      }}
    >
      <svg viewBox="0 0 380 260" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "auto", display: "block" }}>
        <rect x="18" y="28" width="344" height="204" rx="18" fill="#141414" stroke="rgba(255,255,255,0.08)" />
        <rect x="18" y="28" width="8" height="204" rx="4" fill={BLUE} />
        <circle cx="48" cy="50" r="4" fill="#E11D2E" />
        <circle cx="64" cy="50" r="4" fill="#F5C518" />
        <circle cx="80" cy="50" r="4" fill={BLUE} />
        <rect x="108" y="44" width="120" height="12" rx="6" fill="rgba(255,255,255,0.12)" />
        <rect x="246" y="42" width="88" height="16" rx="8" fill={BLUE} />

        <rect x="40" y="78" width="96" height="72" rx="10" fill="#1C1C1C" stroke="rgba(255,255,255,0.06)" />
        <rect x="52" y="92" width="48" height="8" rx="4" fill="rgba(255,255,255,0.18)" />
        <rect x="52" y="108" width="72" height="6" rx="3" fill="rgba(255,255,255,0.08)" />
        <rect x="52" y="120" width="58" height="6" rx="3" fill="rgba(46,107,230,0.45)" />

        <rect x="148" y="78" width="96" height="72" rx="10" fill="#1C1C1C" stroke="rgba(255,255,255,0.06)" />
        <rect x="160" y="92" width="54" height="8" rx="4" fill="rgba(255,255,255,0.18)" />
        <rect x="160" y="108" width="68" height="6" rx="3" fill="rgba(255,255,255,0.08)" />
        <rect x="160" y="120" width="40" height="6" rx="3" fill="rgba(46,107,230,0.55)" />

        <rect x="256" y="78" width="88" height="72" rx="10" fill="#1C1C1C" stroke="rgba(255,255,255,0.06)" />
        <rect x="268" y="92" width="44" height="8" rx="4" fill="rgba(255,255,255,0.18)" />
        <rect x="268" y="108" width="64" height="6" rx="3" fill="rgba(255,255,255,0.08)" />
        <rect x="268" y="120" width="36" height="6" rx="3" fill="rgba(255,255,255,0.12)" />

        <path
          d="M52 186C88 168 124 208 168 186C212 164 248 176 312 158"
          stroke={BLUE}
          strokeWidth="3.2"
          strokeLinecap="round"
        />
        <circle cx="52" cy="186" r="7" fill={BLUE} />
        <circle cx="168" cy="186" r="7" fill="#fff" stroke={BLUE} strokeWidth="2.4" />
        <circle cx="312" cy="158" r="8" fill={BLUE} />
        <circle cx="312" cy="158" r="3.2" fill="#fff" />
      </svg>
    </Box>
  );
}
